<template>
  <cropper
    :admin-context="isAdminLocalization"
    :image="cropImage"
    :aspect-ratio="aspectRatio"
    :is-portrait="isPortrait"
    :name="name"
    @dismissed="$emit('dismissed')"
    @cropped="$emit('cropped', $event)"
  />
</template>

<script>
import AdminContext from '@/admin-i18n/context'


import { dataURLToImage } from './../../../utils'
import Vue from 'vue'
import Cropper from './../cropper'

export default {
  mixins: [AdminContext],
  name:'cropper-dialog',
  components: {
    Cropper,
  },
  props: {
    aspectRatio: Number,
    image: String,
  },
  data(){
    return {
      cropper: null,
      cropImage: null,
      isPortrait: false,
      name: null,
    }
  },
  watch: {
    async image(value){
      if(value) {
        const image = await dataURLToImage(this.image)
        this.isPortrait = image.height>image.width
        await Vue.nextTick()
        this.cropImage = value
      } else {
        this.cropImage = null
      }
    },
  },
  created: function(){
    this.name= Math.random().toString(20).substr(2, 4)
  },
  async mounted() {
    this.cropper = this.$refs.cropper
  },
}
</script>

<style>

</style>
